<script setup lang="ts">
import UnstyledButton from '@/components/base/UnstyledButton.vue';

const { size = 'default' } = defineProps<{ size?: 'small' | 'default' }>();
defineEmits<{ click: [] }>();
const closeIcon = nutshell['img/close.svg'];

const BUTTON_SIZES = {
  small: 'w-5 h-5',
  default: 'w-6 h-6',
};
</script>

<template>
  <UnstyledButton
    class="flex overflow-hidden justify-center items-center p-1 rounded bg-white/50"
    :class="BUTTON_SIZES[size]"
    @click="$emit('click')"
  >
    <img
      alt="Close"
      class="w-3.5 h-3.5 md:w-4 md:h-4 shrink-0"
      data-test="close-modal"
      :src="closeIcon"
    />
  </UnstyledButton>
</template>
